import React from 'react';

import moment from "moment";
import LicensesDocuments from '../LicensesDocuments';
import UserAddress from "../UserAddress"

import {
    Layout, Menu, Spin, Row, Col, message
} from 'antd';
import MiCompAPI from '../../../util/api';
import AgencyPlanandProfile from './AgencyPlanandProfile';
const { Content } = Layout;
class Agency extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            currentTab: this.props.location.state["tab"] === "doc" ? "licenses" : "general",
            agencydata: null,
        }

        this.api = new MiCompAPI(this.props.userPermandMasters);
    }
    componentDidMount() {
        this.getAgencyDetails();
    }


    getAgencyDetails = (state_updates = {}) => {
        this.setState({ isLoading: true });
        this.api.invoke("MyAgencyProfileGetById/" + this.props.location.state["agency_id"], "get", (data, success) => {
            if (success) {
                if (data.statusCode === 200) {
                    this.setState({ ...state_updates, agencydata: data.data, isLoading: false });
                } else {
                    message.destroy();
                    message.error(data.statusMessage, 3);
                }
            }
        });
    }

    handleClick = (e) => {
        this.setState({
            currentTab: e.key,
        });
    }



    getSelectedTabView() {
        if (this.state.isLoading) {
            return (
                <div className="mi_main" style={{ textAlign: 'center' }}>
                    <Spin size="large" />
                </div>
            );
        }
        switch (this.state.currentTab) {
            case "general":
                {
                    let primaryContactDetailsCard, addressCard;

                    primaryContactDetailsCard = (
                        <div className="mi_main" style={{marginRight:"12px"}}>
                            <Row span={24}>
                                <Col span={18}>
                                    <p className='mi_title' style={{ color: '#fd828d' }}>              Company Details  </p>
                                </Col>
                                <Col span={9}>
                                </Col>
                            </Row>
                            <Row>
                                <Col md={5} sm={24}>
                                    <p className="mi_name">Company Name</p>
                                    <p className="mi_value">{this.state.agencydata.agency.agency_Name ? this.state.agencydata.agency.agency_Name : 'none'}</p>
                                </Col>
                                <Col md={4} sm={24}>
                                    <p className="mi_name">Primary Contact Name</p>
                                    <p className="mi_value">{
                                        (this.state.agencydata.agency.primary_Contact_Last_Name ? this.state.agencydata.agency.primary_Contact_Last_Name : "") + " " + (this.state.agencydata.agency.primary_Contact_Middle_Name ? this.state.agencydata.agency.primary_Contact_Middle_Name : "") + " " + (this.state.agencydata.agency.primary_Contact_First_Name ? this.state.agencydata.agency.primary_Contact_First_Name : "")
                                    }</p>
                                </Col>


                                <Col md={5} sm={24}>
                                    <p className="mi_name">Primary Contact Email Address</p>
                                    <p className="mi_value">{this.state.agencydata.agency.primary_Contact_Email ? this.state.agencydata.agency.primary_Contact_Email : 'none'}</p>
                                </Col>
                                <Col md={4} sm={24}>
                                    <p className="mi_name">Primary Contact Number</p>
                                    <p className="mi_value">
                                        {this.state.agencydata.agency.primary_Contact_Phone && this.state.agencydata.agency.primary_Contact_Phone.length === 17 ? <a href={"tel:+" + this.state.agencydata.agency.primary_Contact_Phone}>{this.state.agencydata.agency.primary_Contact_Phone}</a> : "Invalid US Number"}
                                    </p>
                                </Col>
                                <Col md={3} sm={24}>
                                    <p className="mi_name">TAX Id</p>
                                    <p className="mi_value"> {this.state.agencydata.agency.tax_Id ? this.state.agencydata.agency.tax_Id : 'none'}</p>
                                </Col>
                                <Col md={3} sm={24}>
                                    <p className="mi_name">NPN</p>
                                    <p className="mi_value"> {this.state.agencydata.agency.npn ? this.state.agencydata.agency.npn : 'none'}</p>
                                </Col>
                            </Row>


                        </div>
                    );


                    addressCard = (
                        <div className="mi_main">
                            <Row span={24}>
                                <Col span={15}>
                                    <p className='mi_title' style={{ color: '#fd828d' }}>Address</p>
                                </Col>
                                <Col span={9}>
                                </Col>
                            </Row>
                        <UserAddress address={this.state.agencydata.addresses}></UserAddress>
                        </div>


                    );

                    return (
                        <div>
                            <Row span={24}>
                                <Col md={24} sm={24}>  {primaryContactDetailsCard}</Col>
                            </Row>
                                <Row span={24}>
                                    <Col md={24} sm={24}>{addressCard}</Col>
                                </Row>
                            <div className="mi_main">
                                <p className='mi_title' style={{ color: '#fd828d' }}>Other Details</p>
                                <Row span={24}>
                                    <Col md={8} sm={24}>
                                        <p className="mi_name">Agency Id</p>
                                        <p className="mi_value">{this.state.agencydata.agency.id ? this.state.agencydata.agency.id : 'none'}</p>
                                    </Col>

                                    <Col md={8} sm={24}>
                                        <p className="mi_name">Created Date </p>
                                        <p className="mi_value">{this.state.agencydata.agency.createdOn ? moment(this.state.agencydata.agency.createdOn).format("MM/DD/YYYY") : 'none'}</p>
                                    </Col>
                                    <Col md={8} sm={24}>
                                        <p className="mi_name">Last Update Date</p>
                                        <p className="mi_value">{this.state.agencydata.agency.updatedOn ? moment(this.state.agencydata.agency.updatedOn).format("MM/DD/YYYY") : 'none'}</p>
                                    </Col>
                                </Row>
                            </div>
                        </div>);
                }
            case "licenses":
                {

                    return (
                        <div>
                            <LicensesDocuments {...this.props} iswrite={false} User_Id={this.state.agencydata&&this.state.agencydata.agency.user_Id} lname={ this.state.agencydata&&this.state.agencydata.agency.primary_Contact_Last_Name} userPermandMasters={this.props.userPermandMasters} isLoading={this.state.isLoading} documents={this.state.agencydata.documents} licenses={this.state.agencydata.licenses}></LicensesDocuments>


                        </div>
                    );
                }

            case "cbr":
                return (
                    <AgencyPlanandProfile User_Id={this.state.agencydata.agency.user_Id}
                        userPermandMasters={this.props.userPermandMasters}
                        agency_id={this.props.location.state["agency_id"]}
                    />
                );
            default:
                break
        }
    }
    render() {
        return (
            <Content>

                <div className="mi_main_div">
                    <p className="mi_title" style={{ marginLeft: '10px' }}>
                        {this.state.agencydata ?
                            this.state.agencydata.agency.agency_Name + " Profile" : "Agency Profile"
                        }
                    </p>
                    <Menu className="mi_general_bar" style={{ width: 'fit-content' }}
                        onClick={this.handleClick}
                        selectedKeys={[this.state.currentTab]}
                        mode="horizontal"
                    >
                        <Menu.Item className="mi_menu_item" key="general">
                            General
                        </Menu.Item>
                        <Menu.Item className="mi_menu_item" key="licenses" >
                            Compliance
                        </Menu.Item>

                        <Menu.Item className="mi_menu_item" key="cbr">
                            Plans and Profiles
                        </Menu.Item>

                    </Menu>
                    {this.getSelectedTabView()}
                </div>
            </Content>
        );
    }
}
export default Agency;